import { LiveClassesAdmin } from "@/components/admin/LiveClassesAdmin";
import { InsightsAdmin } from "@/components/admin/InsightsAdmin";
import { SopAdmin } from "@/components/admin/SopAdmin";
import { N2PackToggle } from "@/components/admin/N2PackToggle";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { InvitationsAdmin } from "@/components/admin/InvitationsAdmin";
import { StudentsAdmin } from "@/components/admin/StudentsAdmin";
import { QuestionsAdmin } from "@/components/admin/QuestionsAdmin";
import { ModulesAdmin } from "@/components/admin/ModulesAdmin";
import { PushAdmin } from "@/components/admin/PushAdmin";
import { ResetAdmin } from "@/components/admin/ResetAdmin";
import { inputCls, btnPrimary } from "@/components/admin/ui";

const TABS = [["kode", "Lembaga & Kontrak"], ["insight", "Insight"], ["siswa", "Siswa"], ["soal", "Soal"], ["modul", "Modul"], ["maskot", "Maskot"], ["notif", "Notifikasi"], ["kelas", "Kelas Daring"], ["care", "Care Center"], ["sop", "SOP"], ["reset", "Reset"]];

function MascotsAdmin() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/mascots").then((r) => setList(r.data)); }, []);
  return (
    <div className="space-y-4" data-testid="admin-mascots">
      <p className="text-sm text-muted-foreground">Master data 13 ekspresi maskot Yutaka. Ekspresi dipilih otomatis sesuai aturan pada kolom "Dipakai saat".</p>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((m) => (
          <div key={m.code} className="soft-card flex items-start gap-3 p-3" data-testid={`admin-mascot-${m.code}`}>
            <img src={`${process.env.REACT_APP_BACKEND_URL}${m.image}`} alt={m.label_id} className="h-20 w-20 shrink-0 rounded-xl object-cover" />
            <div className="min-w-0 text-sm">
              <p className="font-semibold">{m.label_id} <span lang="ja" className="jp font-normal text-muted-foreground">{m.label_jp}</span></p>
              <p className="text-xs text-muted-foreground"><code className="rounded bg-muted px-1">{m.code}</code> · {m.usage}</p>
              <p className="mt-1 text-xs">{m.msg_id}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function CareAdmin() {
  const [wa, setWa] = useState("");
  useEffect(() => { api.get("/care/categories").then((r) => setWa(r.data.whatsapp)); }, []);
  const save = async () => {
    try { const { data } = await api.put("/admin/care-whatsapp", { whatsapp: wa }); setWa(data.whatsapp); toast.success("Nomor Care Center diperbarui"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="soft-card p-5" data-testid="admin-care">
      <label htmlFor="wa" className="block text-sm font-medium">Nomor WhatsApp Care Center</label>
      <p className="mt-1 text-xs text-muted-foreground">Format internasional tanpa +, contoh 628119216980</p>
      <div className="mt-3 flex gap-2"><input id="wa" data-testid="admin-whatsapp-input" value={wa} onChange={(e) => setWa(e.target.value)} className={inputCls} /><button data-testid="admin-whatsapp-save" onClick={save} className={btnPrimary}>Simpan</button></div>
    </div>
  );
}

export default function Admin() {
  const [tab, setTab] = useState("kode");
  const [studentFilter, setStudentFilter] = useState("");
  const [focus, setFocus] = useState(null);
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, [tab]);
  return (
    <div className="space-y-6 fade-up" data-testid="admin-page">
      <div>
        <p className="font-jpserif text-sm tracking-[0.3em] text-primary">管理</p>
        <h1 className="mt-3 font-jpserif text-3xl sm:text-4xl">Panel Super Admin</h1>
        {stats && <div className="mt-4 flex flex-wrap gap-2 text-xs" data-testid="admin-stats">{[["Siswa", stats.students], ["Soal", stats.questions], ["Modul", stats.modules], ["Assessment", stats.assessments], ["Mini test", stats.tests]].map(([l, v]) => <span key={l} className="rounded-full bg-muted px-3 py-1"><span className="font-semibold">{v}</span> {l}</span>)}</div>}
      </div>
      <div className="inline-flex max-w-full overflow-x-auto rounded-full border border-border bg-card p-1 text-sm" data-testid="admin-tabs">
        {TABS.map(([k, l]) => <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)} className={`whitespace-nowrap rounded-full px-4 py-2 transition-colors ${tab === k ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"}`}>{l}</button>)}
      </div>
      {tab === "kode" && <InvitationsAdmin onSelectCode={(c) => { setStudentFilter(c); setTab("siswa"); }} />}
      {tab === "insight" && <InsightsAdmin onOpenSource={(t) => { setFocus(t); setTab(t.tab); }} />}
      {tab === "sop" && <SopAdmin />}
      {tab === "siswa" && <StudentsAdmin filter={studentFilter} onFilter={setStudentFilter} />}
      {tab === "soal" && <QuestionsAdmin focus={focus?.tab === "soal" ? focus : null} onBack={focus ? () => { setFocus(null); setTab("insight"); } : null} />}
      {tab === "modul" && <><N2PackToggle /><ModulesAdmin focus={focus?.tab === "modul" ? focus : null} onBack={focus ? () => { setFocus(null); setTab("insight"); } : null} /></>}
      {tab === "maskot" && <MascotsAdmin />}
      {tab === "kelas" && <LiveClassesAdmin />}
      {tab === "notif" && <PushAdmin />}
      {tab === "reset" && <ResetAdmin />}
      {tab === "care" && <CareAdmin />}
    </div>
  );
}
